import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FormikCheckbox from '../../ui/FormikCheckbox';

import { UserInfo1Schema } from './validation';
import { updateUser, checkEmail } from '../actions';

const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

class AccountInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      resetForm: false,
      validEmail: true,
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.setValidEmailState = this.setValidEmailState.bind(this);
  }

  setValidEmailState(validEmail) {
    this.setState({ validEmail: validEmail });
  }

  handleEmailChange(e) {
    let { dashboard, dispatch } = this.props;
    dispatch(checkEmail(e.target.value, dashboard.user._id, this.setValidEmailState));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user && this.state.resetForm) {
      this.state.resetForm();
      this.setState({ resetForm: false });
    }
  }

  onSubmit(values, { resetForm }) {
    let { dispatch } = this.props;
    if (this.state.validEmail) {
      this.setState({ resetForm: resetForm });
      dispatch(updateUser(values));
    }
  }

  render() {
    let { dashboard } = this.props;
    const cssFormControlError = "form-control error-input";
    const cssFormControl = "form-control";
    return (<Formik
      validationSchema={UserInfo1Schema}
      initialValues={dashboard.user}
      onSubmit={this.onSubmit}>
      {({ errors, touched, dirty, isSubmitting }) => (
        <Form>
          <div>
            <div className="fieldgroup">
              <label htmlFor="firstName">First Name</label>
              <Field
                name="firstName"
                type="text"
                className={(errors.firstName && touched.firstName) ? cssFormControlError : cssFormControl}
              />
              <ErrorMessage name="firstName" component="div" className="error-message" />
            </div>
            <div className="fieldgroup">
              <label htmlFor="lastName">Last Name</label>
              <Field
                name="lastName"
                type="text"
                className={(errors.lastName && touched.lastName) ? cssFormControlError : cssFormControl}
              />
              <ErrorMessage name="lastName" component="div" className="error-message" />
            </div>
            <div className="fieldgroup">
              <label htmlFor="email">Email</label>
              <Field
                name="email"
                type="email"
                onBlur={this.handleEmailChange}
                className={((errors.email || !this.state.validEmail) && touched.email) ? cssFormControlError : cssFormControl}
              />
              {!this.state.validEmail && (<div className="error-message">Email already in use. Please use another email address.</div>)}
              <ErrorMessage name="email" component="div" className="error-message" />
            </div>
            <div className="fieldgroup">
              <label htmlFor="phoneNumber">Phone Number</label>
              <Field
                name="phoneNumber"
                type="text"
                className={(errors.phoneNumber && touched.phoneNumber) ? cssFormControlError : cssFormControl}
              />
              <ErrorMessage name="phoneNumber" component="div" className="error-message" />
            </div>
          </div>
          <div>
            Notification settings:
          </div>
          <div>
            <div className="fieldgroup">
              <FormikCheckbox
                name="notificationTypes"
                label="Email"
                value="email"
              />
            </div>
            <div className="fieldgroup">
              <FormikCheckbox
                name="notificationTypes"
                label="SMS / Text Message"
                value="sms"
              />
            </div>
          </div>
          <div className="button-row row">
            <div className="col">
              {dirty && !isSubmitting
                ? (<button className="btn btn-primary" type="submit">Update</button>)
                : (<button className="btn btn-primary" disabled={true} type="submit">Update</button>)
              }
            </div>
          </div>
        </Form>
      )}
    </Formik>)
  }
}

export default connect(mapStateToProps)(AccountInformation);
